"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OptionCard = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactIntl = require("react-intl");

var _messages = _interopRequireDefault(require("./messages"));

var _isNil = _interopRequireDefault(require("lodash/isNil"));

var _cloneDeep = _interopRequireDefault(require("lodash/cloneDeep"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _Card = _interopRequireDefault(require("@cimpress/react-components/lib/Card"));

var _DataExpander = _interopRequireDefault(require("./DataExpander"));

var _colors = require("@cimpress/react-components/lib/colors");

var _emotion = require("emotion");

var _helper = require("./helper");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  margin: 7px;\n  font-size: 13px;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  margin: 7px;\n  font-size: 13px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  margin-bottom: 20px;\n  color: inherit;\n  display: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  margin-bottom: 20px;\n  color: inherit;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var position = (0, _emotion.css)(_templateObject());

var cardHeader = function cardHeader(color) {
  return (0, _emotion.css)(_templateObject2(), color);
};

var cardDivCss = function cardDivCss(display) {
  return (0, _emotion.css)(_templateObject3(), display);
};

var valuesText = (0, _emotion.css)(_templateObject4(), _colors.info.darkest);
var unchangedValuesText = (0, _emotion.css)(_templateObject5(), _colors.shale);
var addedValueTag = {
  borderColor: "".concat(_colors.info.darkest),
  color: "".concat(_colors.info.darkest),
  margin: "5px"
};
var removedValueTag = {
  borderColor: "".concat(_colors.info.darkest),
  color: "".concat(_colors.info.darkest),
  margin: "5px",
  textDecoration: "line-through"
};

var OptionCard = function OptionCard(_ref) {
  var option = _ref.option,
      cardCss = _ref.cardCss,
      v1 = _ref.v1;

  var _useIntl = (0, _reactIntl.useIntl)(),
      formatMessage = _useIntl.formatMessage;

  var seeMoreCount = 10;
  var addedValues, unchangedValues, removedValues;

  if (!(0, _isNil["default"])(v1)) {
    addedValues = [];
    unchangedValues = [];
    removedValues = (0, _cloneDeep["default"])(v1.values);
    (0, _helper.segregateValues)(unchangedValues, addedValues, removedValues, v1.values, option.values);
  }

  return (0, _isNil["default"])(v1) ?
  /*#__PURE__*/
  _react["default"].createElement(_Card["default"], {
    className: position,
    key: option.name,
    header:
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: cardHeader(cardCss.color)
    }, option.name),
    style: cardCss
  }, option.values &&
  /*#__PURE__*/
  _react["default"].createElement(_DataExpander["default"], {
    data: option.values,
    count: seeMoreCount,
    tagCss: {
      margin: '5px',
      color: cardCss.color,
      borderColor: cardCss.color,
      textDecoration: cardCss.textDecoration
    }
  })) :
  /*#__PURE__*/
  _react["default"].createElement(_Card["default"], {
    header: option.name,
    className: position
  },
  /*#__PURE__*/
  _react["default"].createElement("div", {
    style: {
      display: 'flex'
    }
  },
  /*#__PURE__*/
  _react["default"].createElement("div", {
    className: cardDivCss(!(0, _isEmpty["default"])(addedValues) ? 'block' : 'none'),
    style: {
      flex: '1'
    }
  },
  /*#__PURE__*/
  _react["default"].createElement("h5", {
    className: valuesText
  }, formatMessage(_messages["default"].addedValues)), addedValues &&
  /*#__PURE__*/
  _react["default"].createElement(_DataExpander["default"], {
    data: addedValues,
    count: seeMoreCount,
    tagCss: addedValueTag
  })),
  /*#__PURE__*/
  _react["default"].createElement("div", {
    className: cardDivCss(!(0, _isEmpty["default"])(removedValues) ? 'block' : 'none'),
    style: {
      flex: '1'
    }
  },
  /*#__PURE__*/
  _react["default"].createElement("h5", {
    className: valuesText
  }, formatMessage(_messages["default"].removedValues)), removedValues &&
  /*#__PURE__*/
  _react["default"].createElement(_DataExpander["default"], {
    data: removedValues,
    count: seeMoreCount,
    tagCss: removedValueTag
  }))),
  /*#__PURE__*/
  _react["default"].createElement("div", {
    className: cardDivCss(!(0, _isEmpty["default"])(unchangedValues) ? 'block' : 'none')
  },
  /*#__PURE__*/
  _react["default"].createElement("h5", {
    className: unchangedValuesText
  }, formatMessage(_messages["default"].unchangedValues)), unchangedValues &&
  /*#__PURE__*/
  _react["default"].createElement(_DataExpander["default"], {
    data: unchangedValues,
    count: seeMoreCount,
    tagCss: {
      margin: "3px"
    }
  })));
};

exports.OptionCard = OptionCard;